<template>
  <div class="giftList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-upload2"
          :disabled="selectedList.length == 0"
          @click="handleshow(2)"
          >批量上架</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-download"
          :disabled="selectedList.length == 0"
          @click="handleshow(1)"
          >批量下架</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加赠品</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">赠品状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="赠品状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="上架中" value="2"></el-option>
          <el-option label="下架中" value="1"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称/厂家"
          @keyup.enter.native="getTableData"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsid"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsname"
        align="center"
        show-overflow-tooltip
        label="配置商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="drug_spec"
        align="center"
        show-overflow-tooltip
        label="商品规格"
      >
      </el-table-column>
      <el-table-column
        prop="package_unit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 2">已上架</el-tag>
          <el-tag type="warning" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 新增赠品 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑赠品</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品类型" prop="GoodsType">
              <el-select
                v-model="addForm.GoodsType"
                placeholder="商品类型"
                disabled
                clearable
                style="width: 200px"
              >
                <el-option
                  v-for="(item, index) in erpTypeNameList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品规格" prop="specification">
              <el-input v-model="addForm.specification" clearable></el-input>
            </el-form-item>
            <el-form-item label="包装单位" prop="packingNnit">
              <el-input v-model="addForm.packingNnit" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产厂家" prop="producer">
              <el-input v-model="addForm.producer" clearable></el-input>
            </el-form-item>
            <el-form-item label="建议零售价" prop="repertory">
              <el-input v-model="addForm.repertory" clearable></el-input>
            </el-form-item>
            <el-form-item label="库存" prop="retailPrice">
              <el-input v-model="addForm.retailPrice" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="封面图片" prop="view">
              <img-upload action="" @fallback="imgFallback"></img-upload>
            </el-form-item> -->
            <el-form-item label="选择图片" prop="view">
              <img-view :imgList="[{ url: addForm.view, id: 0 }]"> </img-view>
              <upload
                @fileChange="beforeAvatarUpload"
                accept="image/jpg,image/jpeg,image/png"
              >
              </upload>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input v-model="addForm.sort" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护买赠活动的赠品</p>
        <p>
          使用场景：<span style="font-weight: bold">促销规则管理</span
          >买赠活动规则选择赠品
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项
export default {
  name: "giftList",
  data() {
    return {
      /**表格数据 */
      //	序号	商品编号	商品名称	商品规格	包装单位	生产厂家	库存	建议零售价	状态	操作
      tableData: [
        {
          number: "商品编号",
          name: "商品名称",
          specification: "商品规格",
          packingNnit: "包装单位",
          producer: "生产厂家",
          repertory: "库存",
          retailPrice: "建议零售价",
          status: "状态",
        },
      ],
      // 商品类型
      erpTypeNameList: [
        { value: "GT2", label: "普通商品" },
        {
          value: "GT3",
          label: "优惠券",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        status: "99",
        name: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增表单 */
      //商品名称 商品规格 包装单位 生产厂家 建议零售价 库存 封面图片 排序值
      addForm: {
        id: "",
        name: "",
        specification: "",
        packingNnit: "",
        producer: "",
        repertory: "",
        retailPrice: "",
        view: "",
        sort: "",
        GoodsType: "",
        goodsName: "",
        goodscode: "",
      },
      /**新增表单规则 */
      addFormRule: {
        id: [mustFill],
        name: [mustFill],
        specification: [mustFill],
        packingNnit: [mustFill],
        producer: [mustFill],
        repertory: [mustFill],
        retailPrice: [mustFill],
        view: [mustFill],
        sort: [mustFill],
      },

      /**使用说明 */
      explain: false,
    };
  },
  created: function () {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**商品图片上传 */
    beforeAvatarUpload(file) {
      if (file.length) {
        this.addForm.view = URL.createObjectURL(file[0]);
        var uploadfile = new FormData();
        uploadfile.append("uploadfile", file[0]);
        var imgType = this.addForm.imgClassify;
        if (imgType == "") {
          this.$message({
            message: "上传失败,请选择图片分类",
            type: "info",
          });
          return;
        }
        this.$uploadRequest({
          url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=goods",
          data: uploadfile,
          method: "post",
        })
          .then((res) => {
            this.addForm.view = this.$setImgUrl(res.message);
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GiftList",
        strWhere: this.searchForm.name,
        status: this.searchForm.status,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_GiftList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "Coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**赠品新增 */
    handleAdd() {
      // this.addDrawer = true;
      this.$router.push("addGift");
    },
    /**点击编辑 */
    handleEdit(row) {
      var data = {
        type: "GiftDt",
        id: row.goodsid,
      };
      var proc = "Proc_Admin_GiftList"; //存储过程名
      var type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.addForm.id = res.data[0].goodsid;
            this.addForm.name = res.data[0].goodsname;
            this.addForm.specification = res.data[0].drug_spec;
            this.addForm.packingNnit = res.data[0].package_unit;
            this.addForm.producer = res.data[0].drug_factory;
            this.addForm.repertory = res.data[0].price;
            this.addForm.retailPrice = res.data[0].Inventory;
            this.addForm.view = this.$setImgUrl(res.data[0].img_url);
            this.addForm.sort = res.data[0].sort_id;
            this.addForm.GoodsType = res.data[0].GoodsType;
          } else {
            this.$message({
              message: res.message,
              type: "info",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
      this.addDrawer = true;
    },
    /**点击删除 */
    handleDel() {
      this.$confirm("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.$refs["addForm"].resetFields();
      for (const key in this.addForm) {
        this.addForm[key] = null;
      }
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          var data = {
            type: "GiftSave",
            id: this.addForm.id,
            sort_id: this.addForm.sort,
            goodsname: this.addForm.name,
            img_url: this.addForm.view,
            Inventory: this.addForm.retailPrice,
            Price: this.addForm.repertory,
            package_unit: this.addForm.packingNnit,
            drug_factory: this.addForm.producer,
            drug_spec: this.addForm.specification,
            GoodsType: this.addForm.GoodsType,
          };
          var proc = "Proc_Admin_GiftList"; //存储过程名
          var type = "ReturnNumber";
          this.$requestSys({
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                for (const key in this.addForm) {
                  this.addForm[key] = null;
                }
                this.addDrawer = false;
              } else {
                this.$message({
                  message: res.message,
                  type: "info",
                });
              }
              this.getTableData();
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    // 批量上架下架
    handleshow(status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        type = "success";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "AuditGifts",
            id: this.selectedList.map((item) => item.goodsid).join(","),
            status: status,
          };
          let proc = "Proc_Admin_GiftList"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**图片成功上传回调 */
    imgFallback(url) {
      this.addForm.view = url;
    },
  },
};
</script>

<style scoped>
.giftList {
  width: 100%;
  height: 100%;
}
</style>
